import { useQuery } from '@apollo/client';
import CssBaseline from '@mui/material/CssBaseline';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import useAuth from '@/common/hooks/useAuth';
import usePermissions from '@/common/hooks/usePermissions';
import { getUserFeatures, getUserProfile, getBusinessProfile } from '@/graphql/queries/user';
import { setProfile, setBusinessProfile } from '@/store/actions/auth';

import Header from './Header/Header';
import Sidebar from './Sidebar/Sidebar';
import useStyles from './styles';

const Layout = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { children } = props;
  const { onSignOut, userType, isLoggedIn, userId, accountId } = useAuth();
  const { setPermissions } = usePermissions();

  useEffect(() => {
    if (userType === 'admin') {
      onSignOut();
    }
  }, []);

  useQuery(getUserFeatures, {
    onCompleted: (data) => setPermissions(data?.getUserFeatures || []),
  });

  useQuery(getUserProfile, {
    variables: { userId },
    skip: !userId,
    onCompleted: (data) => dispatch(setProfile(data?.userData)),
  });

  useQuery(getBusinessProfile, {
    variables: { accountId },
    skip: !accountId,
    onCompleted: (data) => dispatch(setBusinessProfile(data?.getBusinessProfile)),
  });

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Header />
      {isLoggedIn && <Sidebar />}
      <div className={classes.content}>
        <div className={classes.appBarSpacer} />
        {children}
      </div>
    </div>
  );
};

export default Layout;
